






















































import TeacherInfoPage from '../../teacher/info/TeacherInfoPage.vue';
import TeacherCommunication2Page from '../../teacher/info/TeacherCommunication2Page.vue';
import TeacherInputCofirmPage from '../../teacher/info/TeacherInputCofirmPage.vue';
import TeacherLeadershipPage from '../../teacher/info/TeacherLeadershipPage.vue';
import TeacherMotivationPage from '../../teacher/info/TeacherMotivationPage.vue';
import CommonDialog from '../../components/organisms/CommonDialog.vue';

import AdditionalInfoPage from '../../teacher/additional/AdditionalInfoPage.vue';
import TeacherPaymentInputPage from '../../teacher/additional/TeacherPaymentInputPage.vue';

import RequiresAnnounce from '../../components/atoms/RequiresAnnounce.vue';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { TeacherService } from '../../biz/remote/TeacherService';
import { MessageDialog } from '../../utils/MessageDialog';
import SimpleCheckBox from '../../components/inputs/SimpleCheckBox.vue';
import { FileUpload } from '../../biz/FileUpload';
import { TeacherFileDTO } from '../../../src_server/entity/dto/TeacherFileDTO';
@Component({
  components: {
    TeacherInfoPage,
    TeacherCommunication2Page,
    TeacherLeadershipPage,
    TeacherMotivationPage,
    TeacherInputCofirmPage,
    AdditionalInfoPage,
    TeacherPaymentInputPage,
    RequiresAnnounce,
    CommonDialog,
    SimpleCheckBox,
  },
})
export default class TeacherInfoMaintenance extends Vue {
  private info: TeacherInfoInputDTO = new TeacherInfoInputDTO();

  iconImageFile?: File;

  currentPage = 0;

  get all() {
    return true;
  }
  private up_icon_image_client_url = '';
  private up_icon_image_file: File | null = null;
  async onUploadFile(value: TeacherFileDTO) {
    console.log('onUploadFile tim', value);
    this.up_icon_image_client_url = value.icon_image_client_url;
    this.up_icon_image_file = value.icon_image_file;
  }

  @Prop({ default: false })
  private forDisplay!: boolean;

  onIconimageAdd(image: File) {
    this.iconImageFile = image;
  }

  set is_show_reservation_page(value: string) {
    // console.log(value);
    this.info.teacher.is_show_reservation_page = value == '1' ? true : false;
  }

  get isShowTop() {
    return this.info.teacher.is_show!;
  }
  set isShowTop(value: boolean) {
    this.info.teacher.is_show = value;
  }

  /**
   * 詳細ボタンのイベントハンドラ
   */
  public show(row: TeacherInfoInputDTO) {
    this.info = row;
    const dialog = this.$refs['teacher_detail_dialog'] as CommonDialog;
    dialog.show();
  }

  hide() {
    const dialog = this.$refs['teacher_detail_dialog'] as CommonDialog;
    dialog.hide();
  }

  async register() {
    console.log(this.info);
    if (!this.info.userAuth.user_id) {
      await MessageDialog.systemError('ユーザーID', 'メンテナンス更新時', this.info.userAuth.user_id);
      return;
    }

    // アイコン写真のアップロード
    console.log('this.up_icon_image_client_url', this.up_icon_image_client_url);
    if (this.up_icon_image_client_url) {
      const fileBiz = new FileUpload();
      console.log('before upload user_id', this.info.userAuth.user_id);
      const result = await fileBiz.fileUpload(this.info.userAuth.user_id, 'teacher_icon', this.up_icon_image_file!);
      console.log('after upload user_id', result);
      this.info.teacher.img_path = result;
    }
    const biz = new TeacherService();
    await biz.maintenanceUpdate(this.info.userAuth.user_id, this.info);

    this.hide();
  }

  async deleteComplete() {
    if (!this.info.userAuth.user_id) {
      await MessageDialog.systemError('ユーザーID', 'メンテナンス更新時', this.info.userAuth.user_id);
      return;
    }
    const isOK = await MessageDialog.confirm(`${this.info.teacher.nickname}/${this.info.teacher.full_name}さんのデータを完全に削除します。この処理は戻せません。よろしいですか？`);
    if (isOK) {
      const biz = new TeacherService();
      await biz.completeDelete(this.info.userAuth.user_id);
      this.$emit('deleted', this.info.userAuth.user_id);
      this.hide();
    }
  }
}
